const statementsPageDataAr = {
    header : {
        image : {
            name : "statements-2.jpg",
            alt : "Statements and plices wallpaper",
        },
    },
    title : "البيانات والسياسات",
    paragraphOne : "تدرك مؤسستنا مدى أهمية تناول قضايا الاستدامة والممارسات البيئية والاجتماعية والحوكمة المؤسسية التي تنال قسطًا هائلاً من اهتمام عملائنا والمتعاملين معنا ومستثمرينا وغيرهم من أصحاب المصلحة. وحرصًا منا على ضمان الاتساق في أنشطة الحوكمة في هذه القضايا، فقد وضعنا مجموعة من السياسات وبيانات النوايا التي تنطبق على جميع المستويات بالمؤسسة وأوردناها بالتفصيل في هذه الصفحة. تلك السياسات والبيانات تعكس التزامنا بتعزيز الاستدامة والحفاظ على البيئة والمسؤولية الاجتماعية والحوكمة السليمة داخل عملياتنا. وتشمل سياساتنا البيئية التركيز على تقليل انبعاثات الكربون والحفاظ على الموارد وتعزيز الطاقة المتجددة وتقليل النفايات والتلوث. بالإضافة إلى ذلك، تتناول سياساتنا الاجتماعية التنوع والشمول والمساواة في الفرص وحقوق الإنسان وممارسات العمل والمشاركة المجتمعية والأعمال الخيرية. وأخيرًا، تضمن سياسات حوكمتنا الممارسات الشفافة والأخلاقية في جميع جوانب عملنا.",
    cards : [
        {
            image : {
                name : "statements-1.jpg",
                alt : "Compliance with Regulations card",
            },
            title : "Compliance with Regulations",
            linkOne : {
                title : "Compliance with regulations",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-2.jpg",
                alt : "Our Corporate Social Responsibility Policy  card",
            },
            title : "Our Corporate Social Responsibility Policy ",
            linkOne : {
                title : "Our Corporate Social Responsibility Policy ",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-1.jpg",
                alt : "Risk Documents  card",
            },
            title : "Risk Documents",
            linkOne : {
                title : "Risk Documents",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-2.jpg",
                alt : "Internal Audit  card",
            },
            title : "Internal Audit",
            linkOne : {
                title : "Internal Audit",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-1.jpg",
                alt : "Governance And Financial Crime Statements  card",
            },
            title : "Governance And Financial Crime Statements",
            linkOne : {
                title : "Governance And Financial Crime Statements",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-2.jpg",
                alt : "Codes of Conduct  card",
            },
            title : "Codes of Conduct",
            linkOne : {
                title : "Codes of conduct",
                path : "/",
            },
        },

    ]
};

export default statementsPageDataAr;